import Vue from 'vue';
import VueI18n from 'vue-i18n';
import it from './it';
import en from './en';

Vue.use(VueI18n);

const messages = {
  it, en
};

export default new VueI18n({
  locale: 'it',
  messages,
});



// WEBPACK FOOTER //
// ./src/i18n/index.js